import { List } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { DealerRoutes } from '../../common/Routes';
import {
  selectUserPerson,
  selectUserRoles,
} from '../../redux/selectors/userDataSelectors';
import AppMenuListLink from './AppMenuListLink';

const PREFIX = 'AppMenuList';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    width: '100%',
    backgroundColor: theme.palette.grey[900],
    paddingTop: '0px',
  },
}));

const AppMenuList = ({ isTemporary }) => {
  const userRoles = useSelector(selectUserRoles);
  const person = useSelector(selectUserPerson);
  const routes = DealerRoutes(userRoles);
  return (
    <Root>
      <List component="nav" className={classes.root}>
        {routes
          .filter(menu => menu.toolbar)
          .map((r, i) => {
            if (
              r.path === '/dealership-summary-report' &&
              !person?.company?.summary_report
            ) {
              return null;
            }
            return r.icon ? (
              <AppMenuListLink
                key={i}
                activeOnlyWhenExact={r.activeWhenExact}
                to={r.path}
                label={r.name}
                icon={r.icon}
                toolbar={r.toolbar}
                divider={r.divider}
                data-test={r['data-test']}
                isTemporary={isTemporary}
              />
            ) : null;
          })}
      </List>
    </Root>
  );
};

export default AppMenuList;
